import React from 'react';
import _ from 'lodash';

import {Field, formValueSelector} from 'redux-form';

import Label from 'components/Label';
import FormField from 'components/FormField';
import {AsyncSelectField, TextField} from 'components/Fields';
import {TenantInfoOption} from 'components/TenantInfo';

const formSelector = formValueSelector('createBooking');

export const initialValues = state => {
  const primaryTenant = formSelector(state, 'primaryTenant.email');
  const secondaryTenant = formSelector(state, 'secondaryTenant.email');

  const primaryTenantFullName = _.get(primaryTenant, 'object.fullName');
  const secondaryTenantFullName = _.get(secondaryTenant, 'object.fullName');

  return {
    primaryTenant: {fullName: primaryTenantFullName},
    secondaryTenant: {fullName: secondaryTenantFullName}
  };
};

const createNewTenantPrompt = label => `Create new tenant "${label}"`;
const buildTenantOptions = data =>
  data.results.map(tenant => ({
    value: tenant.email,
    label: tenant.email,
    object: tenant
  }));

const TenantsSection = ({
  primaryTenant,
  secondaryTenant,
  fetchTenants,
  clearTenant,
  roomType,
  disablePrimaryTenantEmail,
  onPrimaryTenantChange
}) => {
  const disablePrimaryTenantName =
    _.isNil(primaryTenant) ||
    (primaryTenant.object && primaryTenant.object.fullName);

  const disableSecondaryTenantEmail = roomType && roomType.object.capacity < 2;

  const disableSecondaryTenantName =
    disableSecondaryTenantEmail ||
    _.isNil(secondaryTenant) ||
    (secondaryTenant.object && secondaryTenant.object.fullName);

  const clearPrimaryTenant = () => clearTenant('primaryTenant');
  const clearSecondaryTenant = () => clearTenant('secondaryTenant');

  const primaryTenantPlaceholder = disablePrimaryTenantName
    ? 'Add primary tenant email first'
    : 'Add primary tenant name';

  const secondaryTenantPlaceholder = disableSecondaryTenantName
    ? 'Add secondary tenant email first'
    : 'Add secondary tenant name';

  return (
    <div>
      <FormField className="primaryTenantField">
        <Label>Primary Tenant Email</Label>
        <Field
          name="primaryTenant.email"
          component={AsyncSelectField}
          creatable={true}
          placeholder="Search for primary tenant ..."
          fetchFunction={fetchTenants}
          buildOptions={buildTenantOptions}
          promptTextCreator={createNewTenantPrompt}
          onClear={clearPrimaryTenant}
          optionRenderer={TenantInfoOption}
          disabled={disablePrimaryTenantEmail}
          onChange={onPrimaryTenantChange}
        />
      </FormField>
      <FormField className="primaryTenantNameField">
        <Label>Primary Tenant Name</Label>
        <Field
          name="primaryTenant.fullName"
          placeholder={primaryTenantPlaceholder}
          component={TextField}
          disabled={disablePrimaryTenantName}
        />
      </FormField>
      <FormField className="secondaryTenantField">
        <Label>Secondary Tenant Email</Label>
        <Field
          name="secondaryTenant.email"
          component={AsyncSelectField}
          creatable={true}
          placeholder="Search for secondary tenant ..."
          fetchFunction={fetchTenants}
          buildOptions={buildTenantOptions}
          promptTextCreator={createNewTenantPrompt}
          onClear={clearSecondaryTenant}
          optionRenderer={TenantInfoOption}
          disabled={disableSecondaryTenantEmail}
        />
      </FormField>
      <FormField className="secondaryTenantNameField">
        <Label>Secondary Tenant Name</Label>
        <Field
          name="secondaryTenant.fullName"
          placeholder={secondaryTenantPlaceholder}
          component={TextField}
          disabled={disableSecondaryTenantName}
        />
      </FormField>
    </div>
  );
};

export default TenantsSection;
